<template>
  <div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div v-for="item in list" :key="item.HouseID" class="xy-list builds-flex">
          <div class="builds nowrap">
            <div class="build-name nowrap">{{ item.HouseName }}</div>
            <div class="build-mark nowrap">
              类别：{{ item.HousetypeName }}<span class="cut-line">|</span>所属楼宇：{{
                item.BuildingName
              }}
            </div>
          </div>
          <div>
            <button class="xy-public-btn" @click="viewBtn(item)">详情</button>
            <div class="build-mark-name">{{ !item.State ? "已停用" : "" }}</div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <view-type :rows="rows" :isView="isView" @listenToChildClose="closeModal"></view-type>
  </div>
</template>
<script>
import { setTimeout } from "timers";
import ViewType from "@/pages/basic/views/venue/type/ViewType";
export default {
  name: "build",
  components: {
    ViewType
  },
  data() {
    return {
      list: [],
      loading: false, // 是否加载中
      finished: false, // 加载是否完成
      isLoading: false, //是否处于下拉刷新状态
      num: 1,
      pageSize: 15,
      isView: false,
      isCreate: false,
      rows: {}
    };
  },
  created() {},
  methods: {
    async onLoad() {
      let res = await this.xyapi.get(`${this.xyMApi}/api/House/GetPage`, {
        PageIndex: this.num,
        PageSize: this.pageSize,
        name: "",
        schoolDistrictID: 0,
        buildingID: 0,
        houseTypeID: 0
      });
      let _list = res.data.data;
      this.list = [...this.list, ..._list];
      this.loading = false;
      this.num++;
      this.finished = this.list.length >= res.data.totalRecords ? true : false;
    },
    onRefresh() {
      setTimeout(() => {
        this.list = [];
        this.num = 1;
        this.isLoading = false;
        this.onLoad();
      }, 500);
    },
    viewBtn(val) {
      this.isView = true;
      this.rows = val;
    },
    closeModal(val) {
      // 监听子组件关闭事件
      this.isView = val;
    },
    editOk(val) {
      // 监听子组件的编辑成功事件
      this.isView = val;
      this.onRefresh();
    },
    createBtn() {
      this.isCreate = true;
    },
    closeCreateModal(val) {
      // 监听子组件关闭事件
      this.isCreate = val;
    },
    createOk(val) {
      // 监听子组件的创建成功事件
      this.isCreate = val;
      this.onRefresh();
    }
  }
};
</script>
<style lang="less" scoped>
.xy-list {
  background: #ffffff;
  height: 150px;
  margin: 18px;
  border-radius: 12px;
  padding: 0 18px;
}
.builds-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .builds {
    flex: 1;
    padding-right: 80px;
    .cut-line {
      color: #ccc;
      padding: 0 10px;
    }
    .build-mark {
      font-size: 24px;
      color: #7f7f7f;
      margin-top: 14px;
    }
    .build-name {
      font-size: 28px;
      font-weight: 600;
    }
  }
  .build-mark-name {
    font-size: 24px;
    color: #cccccc;
    text-align: center;
    margin-top: 8px;
  }
}
.create-build {
  position: fixed;
  left: 40px;
  bottom: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #4196ff;
  box-shadow: 0px 4px 12px 4px rgba(65, 150, 255, 0.5);
}
</style>
